import { Select, SelectOption } from '@tblabs/truffle';
import { Translations } from '../../Translations/Translations';


export class LanguageSelector extends Select<string>
{
    constructor(_lang: Translations)
    {
        super(_lang.Lang,
            [
                new SelectOption("🧅 Język polski", "PL"),
                new SelectOption("🍓 English", "EN"),
                new SelectOption("🍒 українська мова", "UK"),
                new SelectOption("🥔 русский язык", "RU"),
                new SelectOption("🍎 Deutsche Sprache", "DE")
            ]);
    }
}
